import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_BATCH_REQUEST = 'GET_BATCH_REQUEST';
export const GET_BATCH_SUCCESS = 'GET_BATCH_SUCCESS';
export const GET_BATCH_FAILURE = 'GET_BATCH_FAILURE';

function requestGetBatch() {
  return {
    type: GET_BATCH_REQUEST,
    isGettingBatch: true
  };
}

function receiveGetBatch(batchItem) {
  return {
    type: GET_BATCH_SUCCESS,
    isGettingBatch: false,
    batchItem
  };
}

function rejectGetBatch() {
  return {
    type: GET_BATCH_FAILURE,
    isGettingBatch: false
  };
}

export function getBatch(batchId) {
  return (dispatch) => {
    dispatch(requestGetBatch());
    const promise = () => ApiService
      .getBatch(batchId)
      .then((response) => {
        dispatch(receiveGetBatch(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetBatch, true));
        }
      });
    return promise();
  };
}
